module.exports = __webpack_public_path__ + "img/goass-logo.7c29c009.svg";